import { Select } from '@it-incubator/ui-kit'
import { PublicVisibility } from 'features/videos/service'

type Props = {
  value: PublicVisibility
  onChange: (value: PublicVisibility) => void
  errorMessage?: string
}

const OPTIONS = [
  {
    label: 'Public (для всех)',
    value: PublicVisibility.Public,
  },
  {
    label: 'Registered (для авторизованных пользователей)',
    value: PublicVisibility.Registered,
  },
  {
    label: 'Subscriber (для платных подписчиков)',
    value: PublicVisibility.Subscriber,
  },
  {
    label: 'None (для наших студентов)',
    value: PublicVisibility.None,
  },
]

export const PublicVisibilitySelector = ({ value, onChange, errorMessage }: Props) => {
  return (
    <Select
      label={'Public visibility'}
      options={OPTIONS}
      value={value}
      onChange={onChange as (value: string) => void}
      portal={false}
      errorMessage={errorMessage}
    />
  )
}
